import { isOrganizationMemberAccount } from '~/utils/userAccountType'

export default async function({ store, error }) {
	if (!store.getters['user/user']) {
		await store.dispatch('user/getUser')
	}

	const user = store.getters['user/user'] || {}

	if (
		!isOrganizationMemberAccount(user) ||
		!user.current_organization
	) {
		return error({
			statusCode: 403,
			message:
				'Access denied: This page is only available to organization users'
		})
	}
}
